import { api } from "../utils/api";

/**
 * Gráficos do diário usam endpoints *-external (RA + campus da sessão).
 * O app família continua em /grade-distribuition, /overall-performance, etc. com WaybeeUserId.
 */

const getGradeDistribuitionChart = async (studentId, period, type) => {
  const res = await api.get(
    `Academics/student/${studentId}/grade-distribuition-external`,
    {
      params: { filter: { schoolYear: new Date().getFullYear(), period, type } }
    }
  );
  return res.data;
};

const getOverallPerformanceChart = async (studentId, period) => {
  const res = await api.get(
    `Academics/student/${studentId}/overall-performance-external`,
    {
      params: { filter: { schoolYear: new Date().getFullYear(), period } }
    }
  );
  return res.data;
};

const getPeriodPerformance = async studentId => {
  const res = await api.get(
    `Academics/student/${studentId}/period-performance-external`,
    {
      params: { filter: { schoolYear: new Date().getFullYear() } }
    }
  );
  return res.data;
};

const getChartStages = async studentId => {
  const res = await api.get(
    `Academics/student/${studentId}/statistics-stages-external`,
    {
      params: { filter: { schoolYear: new Date().getFullYear() } }
    }
  );
  return res.data;
};

export default {
  getGradeDistribuitionChart,
  getOverallPerformanceChart,
  getPeriodPerformance,
  getChartStages
};
